/**
 * reference: @/app/interface/platform.ts
 */

// Products
export enum ProductType {
    GLOBAL_STOCKS = "GLOBAL_STOCKS",
    US_STOCKS = "US_STOCKS",
    US_ETF = "US_ETF",
    BULLION = "BULLION",
    MUTUAL_FUNDS = "MUTUAL_FUNDS",
    INDIAN_STOCKS = "INDIAN_STOCKS",
    BROKING = "BROKING",
    UNLISTED_EQUITY = "UNLISTED_EQUITY",
    FIXED_DEPOSITS = "FIXED_DEPOSITS",
    BONDS = "BONDS",
    LISTED_BONDS = "LISTED_BONDS",
    LISTED_MLDS = "LISTED_MLDS",
    UNLISTED_BONDS = "UNLISTED_BONDS",
    UNLISTED_MLDS = "UNLISTED_MLDS",
    IPOS = "IPOS",
}

export const globalStocks = {
    US_STOCKS: "US_STOCKS",
    US_ETF: "US_ETF",
} as const;

export type GlobalStocks = keyof typeof globalStocks;

export const generalProdctType = {
    STOCK: "STOCK",
    ETF: "ETF",
} as const;

// export type GeneralProdctType = keyof typeof generalProdctType;

export const productRoute = {
    "us-stocks": "us-stocks",
    "us-etfs": "us-etfs",
} as const;

// export type ProductRoute = keyof typeof productRoute;

export const countryProduct = {
    "us-stocks": "STOCK",
    "us-etfs": "ETF",
} as const;

export type ProductRoute = keyof typeof countryProduct;
export type GeneralProdctType = (typeof countryProduct)[keyof typeof countryProduct];

export type GetRouteWiseProductProps =
    | { route: ProductRoute; type?: never }
    | { type: GeneralProdctType; route?: never };

export function getRouteWiseProduct(props: { route: ProductRoute }): GeneralProdctType;
export function getRouteWiseProduct(props: { type: GeneralProdctType }): ProductRoute;
export function getRouteWiseProduct({
    route,
    type,
}: GetRouteWiseProductProps): ProductRoute | GeneralProdctType {
    if (route) {
        return countryProduct[route];
    }
    const entry = Object.entries(countryProduct).find(([, value]) => value === type);
    return entry?.[0] as ProductRoute;
}
